import { Fragment } from 'react';

import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';

import { useSearchPageTranslation } from '../../../../../i18n';
import st from '../../popovers.module.sass';

export function AddressTab(): JSX.Element {
  const { t } = useSearchPageTranslation();
  const { register, formState: { errors }, setValue } = useFormContext();

  return (
    <Fragment>
      <div>
        <Control.Input
          id="cities"
          label={t('filters.event_filters.location.address_tab.city') ?? ''}
          {...register('cities', {
            maxLength: validate.maxLength(36),
          })}
          errors={errors}
          isClearable
          onClear={() => setValue('cities', '')}
        />
      </div>
      <div>
        <Control.Input
          id="areas"
          label={t('filters.event_filters.location.address_tab.area') ?? ''}
          {...register('areas', {
            maxLength: validate.maxLength(36),
          })}
          errors={errors}
          isClearable
          onClear={() => setValue('areas', '')}
        />
      </div>
      <div>
        <Control.Input
          id="districts"
          label={t('filters.event_filters.location.address_tab.district') ?? ''}
          {...register('districts', {
            maxLength: validate.maxLength(36),
          })}
          errors={errors}
          isClearable
          onClear={() => setValue('districts', '')}
        />
      </div>
      <div className={st.RowInputsWrapper}>
        <div>
          <Control.Input
            id="streets"
            label={t('filters.event_filters.location.address_tab.street') ?? ''}
            {...register('streets', {
              maxLength: validate.maxLength(36),
            })}
            errors={errors}
            isClearable
            onClear={() => setValue('streets', '')}
          />
        </div>
        <div>
          <Control.Input
            id="house_numbers"
            label={t('filters.event_filters.location.address_tab.house_number') ?? ''}
            {...register('house_numbers', {
              maxLength: validate.maxLength(36),
            })}
            errors={errors}
            isClearable
            onClear={() => setValue('house_numbers', '')}
          />
        </div>
      </div>
    </Fragment>
  );
}
